import React, { useState } from "react";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";

interface ExportPopupProps {
  total: number;
  data: any[];
  onClose: () => void;
}

const ExportPopup: React.FC<ExportPopupProps> = ({ total, data, onClose }) => {
  const [exportCount, setExportCount] = useState(total);
  const [format, setFormat] = useState<"excel" | "pdf">("excel");

  const handleExport = () => {
    const limitedData = data.slice(0, exportCount);

    // ✅ Bentuk data sesuai kolom yang ingin diexport
    const exportData = limitedData.map((item, index) => ({
      No: index + 1,
      Nama: item.name,
      Email: item.email,
      "No Telepon": item.no_tlpn || "-",
      Role: item.role,
      Status: item.is_confirm === "1" ? "Aktif" : "Tidak Aktif",
    }));

    if (format === "excel") {
      // ✅ Export ke Excel
      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Admin");
      XLSX.writeFile(workbook, "Data_Admin.xlsx");
    } else {
      // ✅ Export PDF TANPA autoTable (manual tapi rapi)
      const doc = new jsPDF();
      doc.setFont("helvetica", "normal");
      doc.setFontSize(12);

      // Judul
      doc.text("Data Admin", 14, 15);
      doc.setLineWidth(0.5);
      doc.line(14, 17, 196, 17);

      // Header tabel
      const headers = ["No", "Nama", "Email", "No Telepon", "Role", "Status"];
      const startY = 25;
      const colWidths = [10, 35, 50, 30, 25, 25];
      let x = 14;

      doc.setFont("helvetica", "bold");
      headers.forEach((header, i) => {
        doc.text(header, x, startY);
        x += colWidths[i];
      });

      doc.setFont("helvetica", "normal");
      let y = startY + 7;

      // Isi tabel
      exportData.forEach((row) => {
        let x = 14;
        Object.values(row).forEach((val: any, i) => {
          const text = String(val);
          doc.text(text, x, y);
          x += colWidths[i];
        });
        y += 7;
      });

      // Garis bawah akhir tabel
      doc.line(14, y + 2, 196, y + 2);

      doc.save("Data_Admin.pdf");
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
      <div className="bg-white rounded-xl shadow-lg p-6 w-80 text-center">
        <h3 className="text-lg font-semibold mb-3">Export Data Admin</h3>

        <label className="block text-sm mb-2">Jumlah data yang akan di-export:</label>
        <input type="number" min={1} max={total} value={exportCount} onChange={(e) => setExportCount(Number(e.target.value))} className="border border-gray-300 rounded-lg px-3 py-2 w-full mb-4" />
        <p className="text-sm text-gray-500 mb-3">Total tersedia: {total} data</p>

        <div className="flex justify-center gap-3 mb-4 w-full">
          <button onClick={() => setFormat("excel")} className={`px-4 py-2 rounded-lg border w-full ${format === "excel" ? "bg-green-500 text-white border-green-500" : "bg-white text-gray-700"}`}>
            Excel
          </button>
          <button onClick={() => setFormat("pdf")} className={`px-4 py-2 rounded-lg border w-full ${format === "pdf" ? "bg-red-500 text-white border-red-500" : "bg-white text-gray-700"}`}>
            PDF
          </button>
        </div>

        <div className="flex justify-end gap-3 mt-8">
          <button onClick={onClose} className="text-gray-500 border px-4 py-2 rounded-lg hover:bg-gray-100">
            Batal
          </button>
          <button onClick={handleExport} className="bg-primary text-white px-4 py-2 rounded-lg hover:bg-blue-700">
            Export
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExportPopup;
